<template>
    <desktop-navbar>
        <div class="flex justify-between" slot="main-nav">
            <div class="flex">
                <a :href="myAccountUrl" class="desktop-nav__br-logo relative desktop-nav__pipe-seperate p-t-lg p-r-lg p-b-lg">
                    <logo></logo>
                </a>
                <a v-for="(vertical, index) in verticalLinks" :key="index" :href="vertical.url" class="relative desktop-nav__pipe-seperate p-lg uppercase">
                    {{ vertical.label }}
                    <div v-if="currentVertical == vertical.slug" class="desktop-nav__vertical-caret"></div>
                </a>
            </div>
            <div v-if="isAuthenticated" class="desktop-nav__dropdown-trigger relative">
                <a href="#" class="block p-t-lg p-l-lg p-b-lg">{{ username }} <i class="fa fa-chevron-down desktop-nav__icon theme-fg-gray--dark" aria-hidden="true"></i></a>
                <div class="absolute desktop-nav__dropdown right">
                    <a v-for="(link, index) in userLinks" :key="index" v-if="!link.hide && link.url" :href="link.url" class="block p-lg">{{ link.label }}</a>
                </div>
            </div>
        </div>

        <div class="flex items-center justify-between" slot="sub-nav">
            <div class="flex">
                <a v-for="(link, index) in mainLinks"
                    :key="index"
                    v-if="!link.hide"
                    v-text="link.label"
                    :href="link.url"
                    :class="{ 'desktop-nav__submenu-active': link.selected }"
                    class="uppercase p-sm m-r-md"
                ></a>
            </div>
            <div class="favorite-star" @click="toggleFavorite" v-if="advertiserId && currentVertical && !favoriteLoading && showFavorite">
                <i v-if="!favoriteUpdating" :class="['fa', isFavorite ? 'fa-star' : 'fa-star-o']" aria-hidden="true"></i>
                <i v-else class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </div>
        </div>
    </desktop-navbar>
</template>

<script>
import Logo from '../logo'
import DesktopNavbar from '../templates/desktop-navbar';

export default {
    components: { Logo, DesktopNavbar },

    props: {
        username: String,
        currentVertical: String,
        myAccountUrl: String,
        mainLinks: Array,
        verticalLinks: Array,
        userLinks: Array,
        isAuthenticated: Boolean,
        advertiserId: Number,
        showFavorite: Boolean
    },

    data() {
        return {
            isFavorite: false,
            favoriteLoading: true,
            favoriteUpdating: false
        }
    },

    methods: {
        checkFavoriteStatus() {
            axios.get(`/api/favorite/advertiser-vertical/${this.advertiserId}/${this.currentVertical}`).then(response => {
                this.isFavorite = response.data.isFavorite;
                this.favoriteLoading = false;
            }).catch(error => {
                // show error
                alert('Error checking favorite status');
            });
        },

        toggleFavorite() {
            if (!this.favoriteUpdating) {
                this.updateFavoriteStatus(this.advertiserId, this.currentVertical);
            }
        },

        updateFavoriteStatus(advertiserId, vertical) {
            this.favoriteUpdating = true;
            if (this.isFavorite) {
                axios.delete(`/api/favorite/advertiser-vertical/${advertiserId}/${vertical}`)
                    .then(response => {
                        this.isFavorite = false;
                        this.favoriteUpdating = false;
                    }).catch(error => {
                        alert('Error removing favorite');
                        this.favoriteUpdating = false;
                    });
            } else {
                axios.post(`/api/favorite/advertiser-vertical/${advertiserId}/${vertical}`)
                    .then(response => {
                        this.isFavorite = true;
                        this.favoriteUpdating = false;
                    }).catch(error => {
                        alert('Error adding favorite');
                        this.favoriteUpdating = false;
                    });
            }
        }
    },

    mounted() {
        if (this.advertiserId && this.currentVertical && this.showFavorite) {
            this.checkFavoriteStatus();
        }
    }
}
</script>

<style scoped>
.favorite-star {
    cursor: pointer;
    font-size: 1.5rem;
    color: #ffd700; /* gold color for the star */
    transition: color 0.3s ease;
}

.favorite-star:hover {
    color: #ffcc00; /* slightly darker gold on hover */
}

.fa-spinner {
    color: #ffd700;
}
</style>
